/**
 * 都道府県マスター（地域別最低賃金）
 *
 * 旧来の PREFECTURES / REGION_MIN_R7_JUL の公開 API は維持しつつ、
 * 値はすべて min-wages.ts の MIN_WAGES から派生させて単一情報源化する。
 *
 * - PREFECTURES[i].regionMin       … 「今日」時点で法令上有効な地域別最低賃金（getCurrentMinWage）
 * - REGION_MIN_R7_JUL[name]        … 加点措置②判定用の R7.7 時点値（= R6改定後）
 * - DEFAULT_PREFECTURE_INDEX       … 既定選択（東京都）
 *
 * 申請日に応じた動的判定が必要な箇所は getCurrentMinWage(name, date) を直接呼ぶこと。
 */

import { MIN_WAGES, getCurrentMinWage, getR77BaselineMinWage } from './min-wages';

export interface Prefecture {
  name: string;
  regionMin: number;
}

// 「今日」時点で各都道府県に有効な地域別最低賃金（多くは R7、未発効の県は R6）。
// 配列順は MIN_WAGES と同じ（北海道→沖縄）。
export const PREFECTURES: readonly Prefecture[] = MIN_WAGES.map((p) => ({
  name: p.name,
  regionMin: getCurrentMinWage(p.name).amount,
}));

export const DEFAULT_PREFECTURE_INDEX = PREFECTURES.findIndex((p) => p.name === '東京都');

// 加点措置②判定用：令和7年7月時点（= R6改定後）の地域別最低賃金
export const REGION_MIN_R7_JUL: Readonly<Record<string, number>> = Object.freeze(
  Object.fromEntries(MIN_WAGES.map((p) => [p.name, getR77BaselineMinWage(p.name)]))
);

// 再エクスポート（呼び出し側が import 元を選べるように）
export { MIN_WAGES, getCurrentMinWage, getR77BaselineMinWage } from './min-wages';
export type { CurrentMinWage, AppliedYear } from './min-wages';
